import { School } from '../school';
export class CardType {
    constructor(
        public id?: number,
        public name?: string,
        public maxAssistancesNum?: number,
        public unlimitedClasses?: boolean,
        public price?: number,
        public duration?: number,
        public exampleValidSince?: any,
        public exampleValidUntil?: any,
        public school?: School,
        public active?: boolean,
        public package_?: boolean,
        public acceptOnlinePayments?: boolean,
        public backOfficeUnitPriceId?: string,
        public description?: string,
        public termsAndConditions?: string,
        public oneTimeOnly?: boolean
    ) {
        this.active = active ? active : false;
        this.oneTimeOnly = oneTimeOnly ? oneTimeOnly : false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type.model.ts